import { Caravan, Check, Phone } from "lucide-react";
import { Reveal, TEL, PHONE } from "./shared";

const points = [
  "Full interior deep clean — floors, surfaces & storage",
  "Kitchen & bathroom sanitizing",
  "Upholstery, cushions & window detailing",
  "Perfect before a road trip, rental or resale",
];

export default function RVCleaning() {
  return (
    <section id="rv-cleaning" data-testid="rv-cleaning" className="bg-white py-24 md:py-32 overflow-hidden">
      <div className="max-w-7xl mx-auto px-6 md:px-12 grid lg:grid-cols-2 gap-14 lg:gap-20 items-center">
        <Reveal>
          <span className="inline-flex items-center gap-2 rounded-full bg-blush px-4 py-2 mb-6 text-teal">
            <Caravan size={18} strokeWidth={1.5} />
            <span className="text-sm uppercase tracking-[0.2em] font-semibold">On The Road Too</span>
          </span>
          <h2 className="font-serif-display text-4xl sm:text-5xl text-teal font-medium leading-tight">
            We clean RVs &amp; trailers
          </h2>
          <p className="mt-5 text-lg text-teal-soft leading-relaxed">
            Your home on wheels deserves the same gentle, detailed care as your home.
            We deep-clean motorhomes, campers and travel trailers inside and out — so you can
            simply pack up and enjoy the adventure.
          </p>
          <ul className="mt-8 space-y-4">
            {points.map((p) => (
              <li key={p} className="flex items-start gap-3">
                <span className="mt-0.5 w-6 h-6 rounded-full bg-pink/40 flex items-center justify-center text-teal shrink-0">
                  <Check size={15} strokeWidth={2} />
                </span>
                <span className="text-teal-soft text-lg">{p}</span>
              </li>
            ))}
          </ul>
          <a
            href={TEL}
            data-testid="rv-call-button"
            className="mt-10 inline-flex items-center gap-3 bg-teal text-white hover:bg-teal-dark rounded-full px-8 py-4 transition-all duration-300 shadow-md hover:shadow-lg"
          >
            <Phone size={18} strokeWidth={1.5} /> Book RV cleaning: {PHONE}
          </a>
        </Reveal>

        <Reveal delay={0.15}>
          <div className="relative">
            <img
              src="https://images.unsplash.com/photo-1634937804768-1b5fa27d7f03?crop=entropy&cs=srgb&fm=jpg&w=900&q=85"
              alt="Clean, bright RV motorhome interior"
              className="rounded-3xl w-full h-[440px] object-cover shadow-[0_20px_60px_rgba(43,81,86,0.15)]"
            />
            <img
              src="https://images.unsplash.com/photo-1596470689751-54f9687c1b7f?crop=entropy&cs=srgb&fm=jpg&w=500&q=85"
              alt="RV parked outdoors"
              className="hidden sm:block absolute -bottom-8 -left-8 w-52 h-40 object-cover rounded-2xl ring-4 ring-white shadow-xl animate-floaty-slow"
            />
          </div>
        </Reveal>
      </div>
    </section>
  );
}
